import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import ddt from '@wix/da-ddt';
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { resetEditorPublishResults, publishComment, publishCommentFailure, publishCommentSuccess, focusEditor, focusDone } from './actionCreators';
const actionHandlers = handleActions({
    [publishComment.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isBusy: true,
            publishResult: null,
            isError: false,
            errorMsg: null
        }),
    [publishCommentSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isBusy: false,
            publishResult: action.payload,
            isError: false,
            errorMsg: null
        }),
    [publishCommentFailure.toString()]: (state, action)=>{
        ddt.log('comments', 'Failed to post comment', action);
        return _object_spread_props(_object_spread({}, state), {
            isBusy: false,
            publishResult: null,
            isError: true,
            errorMsg: action.payload.errorMsg
        });
    },
    [resetEditorPublishResults.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isBusy: false,
            publishResult: null,
            isError: false,
            errorMsg: null
        }),
    [focusEditor.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isFocusRequested: true
        }),
    [focusDone.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isFocusRequested: false
        })
}, {
    isBusy: false,
    publishResult: null,
    isError: false,
    errorMsg: null,
    isFocusRequested: false
});
const reducers = {
    [reduxKey]: (state = {}, action)=>{
        // Server errors if we don't check for an undefined action here.
        if (!action || !action.payload || !action.type) {
            return state;
        }
        const { editorId } = action.payload;
        if (!editorId) {
            return state;
        }
        const innerState = state[editorId];
        const newInnerState = actionHandlers(innerState, action);
        return _object_spread_props(_object_spread({}, state), {
            [editorId]: newInnerState
        });
    }
};
export default reducers;

//# sourceMappingURL=reducers.js.map